import { RootState } from '../store'
import { selectCalendarRangeWithDates } from '../reducers/report-filter'

export const reportFilterSelector = (state: RootState) => {
  return selectCalendarRangeWithDates(state)
}
